class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.selector = this.dataset.selector;
  }

  connectedCallback() {
    this.scaleSlideShowSlider();
  }

  /**
   * Slider custom per le section "scale-slideshow" e "related-scaled-article".
   * Il parametro slidesPerView è molto importante perchè determina quante slides animare,
   * quindi principalmente sono quelle che sono in view.
   */
  scaleSlideShowSlider() {
    const self = this;

    let totalSlides = this.querySelectorAll(`.${this.selector} .tw-custom-slider-slide`);
    let slidesPerView = parseInt(this.getAttribute('slides-per-view'));
    let activeSlide = this.querySelector(`.${this.selector} .tw-custom-slider-slide--active`);
    let activeSlideIndex = parseInt(this.getAttribute('slide-active-index'));

    let arrowNext = this.querySelector(`.${this.selector} .custom-slider-button-next`);    
    let arrowPrev = this.querySelector(`.${this.selector} .custom-slider-button-prev`);

    let animationDelay = 150; //Default

    // Mobile layout fino a 1023px
    if (window.matchMedia('(max-width:1023px)').matches) {
      if (totalSlides.length <= 3) {
        animationDelay = 150; //Se ci sono 3 o meno slides
      } else {
        animationDelay = 100; //Default e Layout 2 slides
      }
    } else {
      if (totalSlides.length <= 3) {
        animationDelay = 200; //Se ci sono 3 o meno slides
      } else if (slidesPerView == "3") {
        animationDelay = 140; //Layout 2 slides (con section.setting.slides_per_view_2)
      } else {
        animationDelay = 150; //Default
      }
    }

    window.addEventListener("resize", function(event) {
      if (window.matchMedia('(max-width:1023px)').matches) {
        if (totalSlides.length <= 3) {
          animationDelay = 150; //Se ci sono 3 o meno slides
        } else {
          animationDelay = 100; //Default e Layout 2 slides
        }
      } else {
        if (totalSlides.length <= 3) {
          animationDelay = 200; //Se ci sono 3 o meno slides
        } else if (slidesPerView == "3") {
          animationDelay = 140; //Layout 2 slides (con section.setting.slides_per_view_2)
        } else {
          animationDelay = 150; //Default
        }
      }
    });
    
    arrowNext.addEventListener('click', function(event) {

      // Vengono nascoste le frecce dello slider
      let arrow_next = event.currentTarget;
      arrow_next.classList.add('hide-arrow');
      arrowPrev.classList.add('hide-arrow');
      
      // Array che conterrà le slides da animare con fade-out
      let slideToFadeOut = [];

      /**
       * Per ogni slide, si verifica se il suo style.order è minore o uguale a slidesPerView.
       * Se soddisfa la condizione, l'elemento viene inserito in slideToFadeOut in una posizione appropriata in base all'attributo order.
       * Ordinamento dal più grande al più piccolo.
       */
      for (let i = 0; i < totalSlides.length; i++) {
        const element = totalSlides[i];
        if (parseInt(element.style.order) <= slidesPerView) {
          // Push the element into the correct position based on order
          const insertIndex = slideToFadeOut.findIndex(e => parseInt(e.style.order) < parseInt(element.style.order));
          if (insertIndex === -1) {
            // If no element with a greater order is found, push it to the end
            slideToFadeOut.push(element);
          } else {
            // Insert the element at the correct position based on order
            slideToFadeOut.splice(insertIndex, 0, element);
          }
        }
      }

      /**
       * Alle slides da nascondere viene aggiunta la classe "scaled-fade-out"
       * Viene usato un setTimeout con un tempo sempre maggiore grazie all'indice del for/of loop
       */
      for (const [index, value] of slideToFadeOut.entries()) {
        setTimeout(() => {
          value.classList.add('scaled-fade-out');
        }, animationDelay * index );
      }

      // Gestisce quale slide deve diventare attiva in base alla precedente
      if (activeSlideIndex == totalSlides.length) {
        activeSlideIndex = 1
      } else {
        activeSlideIndex = activeSlideIndex + 1;
      }

      /**
       * Viene ritardata la partenza del for/of loop che riordina le slides in modo da ordinarle quando sono nascoste.
       * Poi vengono ordinate le slides con la classe "scaled-fade-out" e ordinate in modo decrescente in base allo style.order.
       * Con un altro setTimeout viene tolta la classe "scaled-fade-out" per avere un effetto fade-in.
       * Infine vengono mostrate di nuovo le frecce.
       */
      let slideToFadeIn = [];
      setTimeout(() => {
        for (const [index, value] of totalSlides.entries()) {
          let elementOrderInteger = parseInt(value.style.order);
          if (elementOrderInteger != 0 ) {
            value.style.order = elementOrderInteger - 1
          } else {
            value.style.order =  totalSlides.length - 1
          }
          self.setAttribute('slide-active-index', activeSlideIndex);
    
          activeSlide.classList.remove("tw-custom-slider-slide--active");
          activeSlide.removeAttribute('aria-current');
    
          activeSlide = self.querySelector('[slide-index="' + activeSlideIndex + '"]');
          activeSlide.classList.add('tw-custom-slider-slide--active');
          activeSlide.setAttribute('aria-current', 'true');

          if (value.classList.contains('scaled-fade-out')) {
            // Push the element into the correct position based on order
            const insertIndex = slideToFadeIn.findIndex(e => parseInt(e.style.order) < parseInt(value.style.order));
            if (insertIndex === -1) {
              // If no element with a greater order is found, push it to the end
              slideToFadeIn.push(value);
            } else {
              // Insert the element at the correct position based on order
              slideToFadeIn.splice(insertIndex, 0, value);
            }
          }

          // Effetto fade-in
          setTimeout(() => {
            for (const [index, value] of slideToFadeIn.entries()) {
              setTimeout(() => {
                value.classList.remove('scaled-fade-out');
              }, animationDelay * index );
            }
          }, animationDelay * slideToFadeIn.length );
          
        }

        // Ricompaiono le frecce
        setTimeout(() => {
          arrow_next.classList.remove('hide-arrow');
          arrowPrev.classList.remove('hide-arrow');
        }, animationDelay * slideToFadeIn.length );

      }, (animationDelay + 30) * slideToFadeOut.length );
    });

    arrowPrev.addEventListener('click', function(event) {

      // Vengono nascoste le frecce dello slider
      let arrow_prev = event.currentTarget;
      arrow_prev.classList.add('hide-arrow');
      arrowNext.classList.add('hide-arrow');
      
      // Array che conterrà le slides da animare con fade-out
      let slideToFadeOut = [];

      /**
       * Per ogni slide, si verifica se il suo style.order è minore o uguale a slidesPerView.
       * Se soddisfa la condizione, l'elemento viene inserito in slideToFadeOut in una posizione appropriata in base all'attributo order.
       * Ordinamento dal più piccolo al più grande.
       */
      for (let i = 0; i < totalSlides.length; i++) {
        const element = totalSlides[i];
        if (parseInt(element.style.order) <= 3) {
          // Push the element into the correct position based on order
          const insertIndex = slideToFadeOut.findIndex(e => parseInt(e.style.order) > parseInt(element.style.order));
          if (insertIndex === -1) {
            // If no element with a greater order is found, push it to the end
            slideToFadeOut.push(element);
          } else {
            // Insert the element at the correct position based on order
            slideToFadeOut.splice(insertIndex, 0, element);
          }
        }
      }

      /**
       * SOLO PER IL TASTO PREVIUS
       * 
       * Inserisce l'elemento con lo style.order più grande all'inizio dell'array per poterlo animare
       */
      if (totalSlides.length > 4) {
        for (let i = 0; i < totalSlides.length; i++) {
          const element = totalSlides[i];
          if (parseInt(element.style.order) == totalSlides.length - 1) {
            slideToFadeOut.unshift(element);
          }
        }
      }

      /**
       * Alle slides da nascondere viene aggiunta la classe "scaled-fade-out"
       * Viene usato un setTimeout con un tempo sempre maggiore grazie all'indice del for/of loop
       */
      for (const [index, value] of slideToFadeOut.entries()) {
        setTimeout(() => {
          value.classList.add('scaled-fade-out');
        }, animationDelay * index );
      }

      // Gestisce quale slide deve diventare attiva in base alla precedente
      if (activeSlideIndex == 1) {
        activeSlideIndex = totalSlides.length
      } else {
        activeSlideIndex = activeSlideIndex - 1;
      }

      /**
       * Viene ritardata la partenza del for/of loop che riordina le slides in modo da ordinarle quando sono nascoste.
       * Poi vengono ordinate le slides con la classe "scaled-fade-out" e ordinate in modo decrescente in base allo style.order.
       * Con un altro setTimeout viene tolta la classe "scaled-fade-out" per avere un effetto fade-in.
       * Infine vengono mostrate di nuovo le frecce.
       */
      let slideToFadeIn = [];
      setTimeout(() => {
        for (const [index, value] of totalSlides.entries()) {
          let elementOrderInteger = parseInt(value.style.order);
          if (elementOrderInteger != totalSlides.length - 1 ) {
            value.style.order = elementOrderInteger + 1
          } else {
            value.style.order =  0
          }
          self.setAttribute('slide-active-index', activeSlideIndex);
    
          activeSlide.classList.remove("tw-custom-slider-slide--active");
          activeSlide.removeAttribute('aria-current');
    
          activeSlide = self.querySelector('[slide-index="' + activeSlideIndex + '"]');
          activeSlide.classList.add('tw-custom-slider-slide--active');
          activeSlide.setAttribute('aria-current', 'true');

          if (value.classList.contains('scaled-fade-out')) {
            // Push the element into the correct position based on order
            const insertIndex = slideToFadeIn.findIndex(e => parseInt(e.style.order) > parseInt(value.style.order));
            if (insertIndex === -1) {
              // If no element with a greater order is found, push it to the end
              slideToFadeIn.push(value);
            } else {
              // Insert the element at the correct position based on order
              slideToFadeIn.splice(insertIndex, 0, value);
            }
          }

          // Effetto fade-in
          setTimeout(() => {
            for (const [indexFadeIn, value] of slideToFadeIn.entries()) {
              setTimeout(() => {
                value.classList.remove('scaled-fade-out');
              }, animationDelay * indexFadeIn );
            }
          }, animationDelay * slideToFadeIn.length );
          
        }

        // Ricompaiono le frecce
        setTimeout(() => {
          arrow_prev.classList.remove('hide-arrow');
          arrowNext.classList.remove('hide-arrow');
        }, animationDelay * slideToFadeIn.length );

      }, (animationDelay + 30) * slideToFadeOut.length );
    });
    
  }

}

customElements.define('custom-slider', CustomSlider);